import { httpPatients } from "./http";

const normalize = (data) => (Array.isArray(data) ? data : data?.results || []);

export async function createAdmission(payload) {
  const { data } = await httpPatients.post("admissions/", payload);
  return data;
}

export async function listAdmissions(params = {}) {
  const { data } = await httpPatients.get("admissions/", { params });
  return normalize(data);
}